module.exports = __webpack_public_path__ + "static/media/Extruded tooth3.21ea1528.png";